export { default as Img200 } from './processed/200/redzel.jpg';
export { default as Img400 } from './processed/400/redzel.jpg';
export { default as Imgthumb } from './processed/thumb/redzel.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/redzel.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/redzel.jpg';
export const ImgData = { width: 600, height: 400, ratio: 0.6666666666666666, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      236,
      41,
      60
    ],
    "_population": 363,
    "_hsl": [
      0.9837606837606838,
      0.8369098712446352,
      0.5431372549019609
    ]
  },
  "LightVibrant": {
    "_rgb": [
      149,
      178,
      231
    ],
    "_population": 335,
    "_hsl": [
      0.6077235772357724,
      0.6307692307692306,
      0.7450980392156863
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      142,
      8,
      13
    ],
    "_population": 50,
    "_hsl": [
      0.9937810945273632,
      0.8933333333333333,
      0.29411764705882354
    ]
  },
  "Muted": {
    "_rgb": [
      67,
      83,
      137
    ],
    "_population": 689,
    "_hsl": [
      0.6285714285714286,
      0.34313725490196073,
      0.4
    ]
  },
  "LightMuted": {
    "_rgb": [
      205,
      177,
      176
    ],
    "_population": 16,
    "_hsl": [
      0.005747126436781587,
      0.2248062015503877,
      0.7470588235294118
    ]
  },
  "DarkMuted": {
    "_rgb": [
      91,
      50,
      46
    ],
    "_population": 690,
    "_hsl": [
      0.014814814814814814,
      0.3284671532846716,
      0.26862745098039215
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/redzel.js